/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import {downloadFile} from '@dvrd/dvr-controls';

export function downloadFileResponse(response: Response, defaultFileName: string) {
    const header = response.headers.get('Content-Disposition');
    let fileName = defaultFileName;
    if (header) fileName = header.substring(header.indexOf('filename=') + 'filename='.length, header.length);
    void response.blob().then((blob: Blob) => downloadFile(blob, fileName));
}
